export default __webpack_public_path__ + "locales/vi/JavascriptSdk.json?hash=1468e57e7429ac6ae7a2dbc1e5a2c451";